export function weekday(num) {
    const weekday = new Array(7);
    weekday[0] = "Sun";
    weekday[1] = "Mon";
    weekday[2] = "Tues";
    weekday[3] = "Wed";
    weekday[4] = "Thur";
    weekday[5] = "Fri";
    weekday[6] = "Sat";
    return weekday[num];
}

export function formatToDate(time) {
    let temp = time.split("@");
    let day = temp[0].split(" ").reverse().join(" ");
    return [day, temp[1]];
}

export function addClass(ele, name) {
    if (name) {
        ele.className ? (ele.className = ele.className + " " + name) : (ele.className = name);
    }
}

export function isJsonString(str: string) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/utils/common.ts